export default __webpack_public_path__ + "static/media/gl.9a54143f.svg";